"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTablet = exports.isMobile = exports.isDesktop = exports.getCurrentBreakPoint = exports.BREAKPOINTS = void 0;
var _server = require("b2b-components/utils/server");
const BREAKPOINTS = exports.BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1366
};
const getCurrentBreakPoint = () => _server.isServer ? BREAKPOINTS.xxl : Math.max(...Object.values(BREAKPOINTS).filter(breakpoint => window.matchMedia(`(min-width: ${breakpoint}px)`).matches));
exports.getCurrentBreakPoint = getCurrentBreakPoint;
const isMobile = exports.isMobile = getCurrentBreakPoint() === BREAKPOINTS.xs || getCurrentBreakPoint() === BREAKPOINTS.sm;
const isTablet = exports.isTablet = getCurrentBreakPoint() === BREAKPOINTS.md;
const isDesktop = exports.isDesktop = getCurrentBreakPoint() === BREAKPOINTS.lg || getCurrentBreakPoint() === BREAKPOINTS.xl || getCurrentBreakPoint() === BREAKPOINTS.xxl;
//# sourceMappingURL=mediaQuery.js.map